document.addEventListener('DOMContentLoaded', function() {
  // --- 1. DOM Elements ---
  const launcher = document.getElementById('klaviyo-popup-launcher');
  const popup = document.getElementById('custom-klaviyo-popup');
  const closeBtn = document.getElementById('close-popup-btn');
  const form = document.getElementById('custom-klaviyo-form');
  const formContent = document.getElementById('popup-form-content');
  const successContent = document.getElementById('popup-success-content');
  const submitBtn = document.getElementById('popup-submit-btn');

  // --- 2. Popup Open/Close Logic ---
  function openPopup() {
    if (popup) popup.classList.add('is-visible');
  }

  function closePopup() {
    if (popup) popup.classList.remove('is-visible');
  }

  if (launcher) launcher.addEventListener('click', openPopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  
  // Close when clicking the dark overlay outside the popup box
  if (popup) {
    popup.addEventListener('click', function(event) {
      if (event.target === popup) closePopup();
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && popup && popup.classList.contains('is-visible')) {
      closePopup();
    }
  });

  // --- 3. Klaviyo Form Submission Logic ---
  if (form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault(); // Stop the page from refreshing

      // Change button state to show it's working
      submitBtn.disabled = true;
      submitBtn.textContent = 'Subscribing...';

      // Grab the user's input
      const firstName = document.getElementById('klaviyo-first-name').value;
      const email = document.getElementById('klaviyo-email').value;
      const shoeChoice = document.getElementById('klaviyo-shoe-choice').value;

      const companyId = 'MXYtNd'; 
      const listId = 'KvwgD8'; // This is your "US Newsletter" list from your logs

      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Custom Shopify Popup", // This will show up in Klaviyo logs instead of 'Cluster'
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: {
                    shoe_preference: shoeChoice // Saves the dropdown choice to their profile
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: listId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'revision': '2024-02-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          // Success! Hide form, show success message with promo code
          formContent.style.display = 'none';
          successContent.style.display = 'block';
          
          // Wire up the new "Continue Shopping" button to close the popup
          const closeSuccessBtn = document.getElementById('close-success-btn');
          if (closeSuccessBtn) {
            closeSuccessBtn.addEventListener('click', function() {
              closePopup();
              // Reset the form in the background in case they open it again later
              setTimeout(() => {
                form.reset();
                formContent.style.display = 'block';
                successContent.style.display = 'none';
                submitBtn.disabled = false;
                submitBtn.textContent = 'Unlock 15% Off';
              }, 300);
            });
          }

        } else {
          // Failure handling
          const errorData = await response.json();
          console.error('Klaviyo Subscription Failed:', errorData);
          alert('Something went wrong. Please check your email format and try again.');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Unlock 15% Off';
        }
      } catch (error) {
        console.error('Network Error:', error);
        alert('A network error occurred. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Unlock 15% Off';
      }
    });
  }
});